// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__rgrFO","cntrWidget":"style_cntrWidget__FZOqV","cntrText":"style_cntrText__Y_Hfd","itemLink":"style_itemLink__97hwL","playerPic":"style_playerPic__d2Gb7"};